import React from 'react'
import { maskMoney } from 'util/masks'
import { paymentMethods, paymentTypes } from '../Order'
import { Order } from '../redux/types'

const Payment: React.FC<{ order: Order }> = ({ order }) => {
  const deliveryTip = order.deliveryTip || 0
  const total = order.total + (order.costDelivery - order.deliveryDiscount) + deliveryTip

  return (
    <div className="row margin-top-32">
      <h2><i className="fas fa-cash-register"/> Pagamento</h2>

      <div className="row margin-top-16">
        <div className="row col-6 padding-right-8">
          <div className="row panel center-center" style={{ height: 155 }}>
            <div className="col-3">
              <p>Sub Total</p>
              <h1>{ maskMoney(order.total) }</h1>
            </div>
            <div className="col-3">
              <p>
                  Entrega
                {
                  order.deliveryDiscount > 0 &&
                  <span className="pop">-{ maskMoney(order.deliveryDiscount) }</span>
                }
              </p>
              <h1>{ maskMoney(order.costDelivery - order.deliveryDiscount) }</h1>
            </div>
            <div className="col-3">
              <p>Gorjeta</p>
              <h1>{ maskMoney(deliveryTip) }</h1>
            </div>
            <div className="col-3">
              <p>Total</p>
              <h1>{ maskMoney(total) }</h1>
            </div>
          </div>
        </div>
        <div className="row col-6 padding-left-8">
          <div className="row panel center-center" style={{ height: 155 }}>
            <p>
              { paymentTypes[order.paymentType] } - { paymentMethods[order.paymentMethod] }
            </p>

            {
              order.paymentType === 'MONEY'
                ? (
                  <div className="row">
                    <div className="form-control col-6">
                      <label>Troco Para</label>
                      <input
                        type="text"
                        value={order.change}
                        disabled
                      />
                    </div>
                    <div className="form-control col-6">
                      <label>Troco</label>
                      <input
                        type="text"
                        value={total - order.change}
                        disabled
                      />
                    </div>
                  </div>
                )
                : (
                  <div className="row justify-start margin-top-16">
                    {
                      order.partner.cardTaxes.map((cardTax, i) => {
                        const isPayment = order.paymentCardTax === cardTax.id
                        const background = isPayment ? 'var(--primary)' : 'var(--secondary)'
                        const color = isPayment ? 'var(--primary-text)' : 'var(--secondary-text)'
                        const filter = isPayment ? 'grayscale(100%) brightness(300%)' : 'none'
                        return (
                          <div
                            key={i}
                            className="row button secondary margin-right-8"
                            style={{ width: 80, padding: 8, height: 65, background }}
                          >
                            <img src={cardTax.icon} width={40} style={{ filter }} alt=""/>
                            <p style={{ fontSize: 11, color }} className="row">{ cardTax.name.split(' ').shift() }</p>
                          </div>
                        )
                      })
                    }
                  </div>
                )
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Payment
